import { ReactNode } from 'react';

import { IPaymentCard } from '@/features/cards/store/models/card.model';

const cardHeaders = [
  'publicToken',
  'statusCode',
  'virtualConverted',
  'walletId',
  'embossedName',
  'startDate',
  'expiryDate',
  'createdDate',
] as const;

type THeadersKeys = (typeof cardHeaders)[number];
export type TAllCardsRowType = {
  [key in keyof Pick<IPaymentCard, THeadersKeys> | 'actions']: ReactNode;
};
export const allcardsHeadersList: (keyof TAllCardsRowType)[] = [...cardHeaders, 'actions'] as const;
